import AppInfoParser from "app-info-parser";

async function fileSelect(file: File) {
  const values = {
    appName: "",
    version: "",
    packageName: "",
    icon: "",
    platform: "",
  };

  const parser = new AppInfoParser(file);

  const result = await parser.parse();

  if (file.name.includes(".ipa")) {
    values.appName = result.CFBundleName;
    values.version = result.CFBundleShortVersionString;
    values.packageName = result.CFBundleIdentifier;
    values.icon = result.icon;
    values.platform = "IOS";
  } else if (file.name.includes(".apk")) {
    if (Array.isArray(result.application.label)) {
      values.appName = result.application.label[0];
    } else {
      values.appName = result.application.label;
    }
    values.version = result.versionName;
    values.packageName = result.package;
    values.icon = result.icon;
    values.platform = "ANDROID";
  }

  return values;
}

export default fileSelect;
